import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeftreact = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 7,
	height: 10,
	viewBox: "0 0 7 10",
	fill: "#2E3A59",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.36204 10.0002C5.10004 10.0002 4.83904 9.89825 4.64304 9.69525L0.78004 5.69525C0.40204 5.30225 0.40704 4.67925 0.79304 4.29325L4.79304 0.29325C5.18304 -0.09775 5.81604 -0.09775 6.20704 0.29325C6.59704 0.68425 6.59704 1.31625 6.20704 1.70725L2.90204 5.01225L6.08104 8.30525C6.46504 8.70325 6.45404 9.33625 6.05704 9.71925C5.86204 9.90725 5.61204 10.0002 5.36204 10.0002Z"
	})
});
export default SvgChevronLeftreact;
